<mat-toolbar>
  <button mat-icon-button (click)="back()" color="primary">
    <mat-icon fontSet="material-icons-outlined">arrow_back_ios</mat-icon>
  </button>
  <!--
  <button mat-icon-button color="primary" (click)="menuService.open.next()">
    <mat-icon fontSet="material-icons-outlined">menu</mat-icon>
  </button>
  -->
</mat-toolbar>
<div class="overflow-container">
  <div *ngIf="!(statusBannerService.hideChromeTitle$ | async) && (titleService.title$ | async) as title" class="mat-headline">
    {{title}}
  </div>
  <router-outlet></router-outlet>
</div>
